module.exports = __webpack_public_path__ + "img/complementos.e3a87ab8.svg";